import React from 'react';
import PropTypes from 'prop-types';
import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalContext, useContextWithValidation } from '@adsk/alloy-react-context';
/**
 * Context for current project ID.
 */
const CurrentProjectIdContext = getOrCreateGlobalContext(CONTEXT_NAMES.CurrentProjectIdContext);
const useCurrentProjectIdContext = () => useContextWithValidation(CurrentProjectIdContext, {
  hook: 'useCurrentProjectIdContext',
  provider: 'CurrentProjectIdProvider'
});
export const useCurrentProjectId = () => {
  const currentProjectIdContext = useCurrentProjectIdContext();
  return currentProjectIdContext === null || currentProjectIdContext === void 0 ? void 0 : currentProjectIdContext.projectId;
};
export const CurrentProjectIdProvider = _ref => {
  let {
    children,
    projectId
  } = _ref;
  return /*#__PURE__*/React.createElement(CurrentProjectIdContext.Provider, {
    value: {
      projectId
    }
  }, children);
};
CurrentProjectIdProvider.displayName = 'CurrentProjectIdProvider';
CurrentProjectIdProvider.propTypes = {
  /** Nodes with access to context */
  children: PropTypes.node,
  /** The project ID */
  projectId: PropTypes.string
};
//# sourceMappingURL=CurrentProjectIdContext.js.map